import RestClient from '@/api/api';

class PromptTemplatesAPI extends RestClient {
  async getAll() {
    return await this._get('/prompt_templates');
  }

  async get(key) {
    return await this._get(`/prompt_templates/${key}`);
  }

  async update(key, promptTemplate) {
    return await this._put(`/prompt_templates/${key}`, { prompt_template: promptTemplate });
  }

  async getVersions(key) {
    return await this._get(`/prompt_templates/${key}/versions`);
  }

  async restore(key, version) {
    return await this._post(`/prompt_templates/${key}/restore`, { version });
  }

  async resetToDefault(key) {
    return await this._post(`/prompt_templates/${key}/reset_to_default`);
  }
}

export default new PromptTemplatesAPI();
